import React, { useState } from 'react';
import CustomNavbar from '../components/navbarUser';
import SidebarUser from '../components/sibebarUser';
import MainContent from '../components/mainContent';
import '../style/dashboard.css'; // Estilos gerais


const IndexUser = () => {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <SidebarUser isOpen={isSidebarOpen} />

      {/* Área de conteúdo */}
      <div className={`main-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Navbar */}
        <CustomNavbar toggleSidebar={toggleSidebar} />

        {/* Conteúdo principal */}
        <MainContent>
          {/* Aqui você pode adicionar o componente DynamicForm */}
          
        </MainContent>
      </div>
    </div>
  );
};

export default IndexUser;
